import { Box } from 'grommet'
import NextLink from 'next/link'
import styled from 'styled-components'

const MAX_WIDTH_WRAPPER = 657

export const Article = styled.h2`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[0]}px;
  margin-bottom: ${({ theme }) => theme.spaces[4]}px;

  text-align: justify;
`

export const ImageWrapper = styled(Box)`
  align-items: center;
  display: flex;
  height: auto;
  margin-bottom: ${({ theme }) => theme.spaces[4]}px;
  position: relative;
  width: 100%;
  img {
    height: auto;
    max-width: 657px;
    object-fit: cover;
    width: 100%;
  }
`

export const Wrapper = styled(Box)`
  align-self: center;
  margin: ${({ theme }) => theme.spaces[5]}px 0
    ${({ theme }) => theme.spaces[4]}px;
  max-width: ${MAX_WIDTH_WRAPPER}px;
  width: 100%;
  ul {
    h2 {
      margin-bottom: ${({ theme }) => theme.spaces[2]}px;
    }
    margin-bottom: ${({ theme }) => theme.spaces[4]}px;
    margin-left: ${({ theme }) => theme.spaces[5]}px;
  }

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.spaces[3]}px;
  `}

  ${({ theme }) => theme.below.mobileL`
    margin-top: ${theme.spaces[4]}px;
  `}
`

export const ImageSectionWrapper = styled.div`
  span {
    color: unset;
    display: block;
    font-weight: ${({ theme }) => theme.fontWeight[6]};
    & > b {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const CustomLink = styled(NextLink)`
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  display: flex;
  justify-content: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
